import { render, staticRenderFns } from "./JobComments.vue?vue&type=template&id=30576161"
import script from "./JobComments.vue?vue&type=script&lang=js"
export * from "./JobComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports